/* NAMA cart drawer — reference design-handoff/cart, but wired to the live
   Shopify Cart AJAX API (spec §5: every mutation talks to Shopify and the
   drawer re-renders from the response, never from the DOM).

   Store note: colour is a sibling product, not a variant option, so the inline
   editor edits the line's real product options (Size / Length). Changing a
   variant is remove + add (spec §4). */
(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  var busy = false;

  // ── open / close ────────────────────────────────────────────────
  function open() { drawer.classList.add('is-open'); document.body.classList.add('nama-cart-open'); }
  function close() { drawer.classList.remove('is-open'); document.body.classList.remove('nama-cart-open'); }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  // Open when the cart icon is clicked (theme markup varies — match broadly)
  document.addEventListener('click', function (e) {
    var trig = e.target.closest('[data-ajax-cart-trigger], .header__cart, a[href$="/cart"], a[href="/cart"], [data-nmd-cart], .nama-cart-icon');
    if (trig && !e.target.closest('[data-cart-drawer]')) {
      // let real cart-page links work if JS cart is disabled; otherwise open drawer
      e.preventDefault();
      // Slide out NOW — contents were server-rendered with the live cart at
      // page load. The background refresh only matters if the cart changed
      // since (post-add flows already refresh before opening).
      open();
      refresh();
    }
  }, true);

  // ── re-render from the server ───────────────────────────────────
  function refresh() {
    return fetch('/cart?view=namadrawer', { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.head') ? doc.body : null;
        if (!fresh) return;
        drawer.innerHTML = doc.body.innerHTML;
        var count = drawer.querySelector('[data-count]');
        var empty = count && /^0\s/.test(count.textContent.trim());
        drawer.classList.toggle('is-empty', !!empty);
        bindEditors();
      });
  }

  // ── quantity / remove / checkout ────────────────────────────────
  function changeLine(key, qty) {
    if (busy) return;
    busy = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function () { return refresh(); })
      .then(syncHeaderCount)
      .finally(function () { busy = false; });
  }

  drawer.addEventListener('click', function (e) {
    var item = e.target.closest('[data-item]');
    if (e.target.closest('[data-checkout]')) { window.location.href = '/checkout'; return; }
    if (!item) return;
    var key = item.getAttribute('data-key');
    var qtyEl = item.querySelector('[data-qty]');
    if (e.target.closest('[data-inc]')) { changeLine(key, +qtyEl.textContent + 1); }
    else if (e.target.closest('[data-dec]')) { if (+qtyEl.textContent > 1) changeLine(key, +qtyEl.textContent - 1); }
    else if (e.target.closest('[data-rm]')) { changeLine(key, 0); }
  });

  // ── caches shared across editors ────────────────────────────────
  var siblingCache = {};  // collection handle -> [{handle,color_name,available,...}]
  var productCache = {};  // product handle    -> {options, variants}

  function fetchSiblings(collection) {
    if (siblingCache[collection]) return siblingCache[collection];
    siblingCache[collection] = fetch('/collections/' + collection + '?sections=cross-product-swatches')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var html = d['cross-product-swatches'];
        try { return JSON.parse(new DOMParser().parseFromString(html, 'text/html').body.textContent.trim()); }
        catch (e) { return []; }
      }).catch(function () { return []; });
    return siblingCache[collection];
  }
  function fetchProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch('/products/' + handle + '.js').then(function (r) { return r.json(); })
      .then(function (p) {
        return {
          options: (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; }),
          variants: p.variants.map(function (v) { return { id: v.id, options: [v.option1, v.option2, v.option3], available: v.available }; })
        };
      }).catch(function () { return null; });
    return productCache[handle];
  }

  // ── inline variant editor (Colour across siblings + Size / Length) ─
  function bindEditors() {
    drawer.querySelectorAll('[data-item]').forEach(function (item) {
      var openBtn = item.querySelector('[data-open]');
      if (!openBtn) return;
      var data;
      try { data = JSON.parse(item.querySelector('[data-variants]').textContent); } catch (e) { return; }

      // this product's own editable option positions (Size / Length)
      var optAxes = data.options
        .map(function (o, i) { return { name: o.name, pos: i }; })
        .filter(function (o) { return /size|length/i.test(o.name); });

      openBtn.addEventListener('click', function () {
        item.classList.add('editing');
        var host = item.querySelector('.specs');
        var old = item.querySelector('.editor'); if (old) old.remove();
        host.insertAdjacentHTML('afterend', '<div class="editor"><p class="eg-l" style="color:var(--nama-muted-soft)">Loading…</p></div>');
        var siblings = data.colour ? fetchSiblings(data.colourCollection) : Promise.resolve([]);
        siblings.then(function (list) { runEditor(item, data, optAxes, list || []); });
      });
    });
  }

  function runEditor(item, data, optAxes, siblings) {
    var esc = function (s) { return String(s).replace(/</g, '&lt;'); };
    // colour options only when there's a real choice (>1 sibling)
    var colours = siblings.length > 1 ? siblings : [];
    var state = {
      colour: data.colour || null,                       // color_name
      colourHandle: data.handle,                         // product currently targeted
      opts: data.current.slice()                         // size/length values by position
    };
    var matrix = { options: data.options.map(function (o) { return o.name; }), variants: data.variants };

    function handleForColour(name) {
      var s = colours.filter(function (c) { return c.color_name === name; })[0];
      return s ? s.handle : data.handle;
    }
    function axisPos(kind) {
      var a = optAxes.filter(function (o) { return new RegExp(kind, 'i').test(o.name); })[0];
      return a ? a.pos : -1;
    }
    function variantIn(mx, values) {
      for (var i = 0; i < mx.variants.length; i++) {
        var v = mx.variants[i], ok = true;
        for (var j = 0; j < values.length; j++) { if (values[j] != null && v.options[j] !== values[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function valueAvailable(pos, val) { var p = state.opts.slice(); p[pos] = val; var v = variantIn(matrix, p); return v && v.available; }

    function render() {
      var ed = item.querySelector('.editor');
      var groups = '';
      if (colours.length) {
        groups += '<div class="eg"><p class="eg-l">Color: <span class="val">' + esc(state.colour) + '</span></p><div class="opts">' +
          colours.map(function (c) {
            var on = c.color_name === state.colour;
            return '<button class="opt" type="button" data-colour="' + esc(c.color_name) + '"' + (on ? ' aria-pressed="true"' : '') +
              (c.available ? '' : ' disabled') + '>' + esc(c.color_name) + '</button>';
          }).join('') + '</div></div>';
      }
      groups += optAxes.map(function (o) {
        var vals = matrix.options[o.pos] ? uniqueValues(o.pos) : [];
        return '<div class="eg"><p class="eg-l">' + esc(o.name) + ': <span class="val">' + esc(state.opts[o.pos] || '') + '</span></p><div class="opts">' +
          vals.map(function (val) {
            var on = state.opts[o.pos] === val;
            var avail = valueAvailable(o.pos, val);
            return '<button class="opt" type="button" data-opt="' + o.pos + '" data-val="' + esc(val) + '"' +
              (on ? ' aria-pressed="true"' : '') + (avail ? '' : ' disabled') + '>' + esc(val) + '</button>';
          }).join('') + '</div></div>';
      }).join('');
      ed.innerHTML = groups + '<div class="ed-act"><button class="ed-save" type="button" data-save>Update</button><button class="ed-cancel" type="button" data-cancel>Cancel</button></div>';
      wire();
    }
    function uniqueValues(pos) {
      var seen = [], out = [];
      matrix.variants.forEach(function (v) { if (seen.indexOf(v.options[pos]) < 0) { seen.push(v.options[pos]); out.push(v.options[pos]); } });
      return out;
    }

    function wire() {
      var ed = item.querySelector('.editor');
      ed.querySelectorAll('.opt[data-colour]:not([disabled])').forEach(function (b) {
        b.addEventListener('click', function () {
          var name = b.getAttribute('data-colour');
          state.colour = name;
          state.colourHandle = handleForColour(name);
          // load the chosen colour's matrix so size availability + ids are correct
          fetchProduct(state.colourHandle).then(function (m) {
            if (m) { matrix = m; }
            var body = drawer.querySelector('.body'); var sc = body.scrollTop; render(); body.scrollTop = sc;
          });
        });
      });
      ed.querySelectorAll('.opt[data-opt]:not([disabled])').forEach(function (b) {
        b.addEventListener('click', function () {
          state.opts[+b.getAttribute('data-opt')] = b.getAttribute('data-val');
          var body = drawer.querySelector('.body'); var sc = body.scrollTop; render(); body.scrollTop = sc;
        });
      });
      ed.querySelector('[data-cancel]').addEventListener('click', function () { item.classList.remove('editing'); ed.remove(); });
      ed.querySelector('[data-save]').addEventListener('click', function () {
        var target = variantIn(matrix, state.opts);
        if (!target || !target.available) return;
        if (String(target.id) === item.getAttribute('data-variant')) { item.classList.remove('editing'); ed.remove(); return; }
        swapVariant(item.getAttribute('data-key'), target.id);
      });
    }

    render();
  }

  // remove the old line, add the chosen variant at the same qty, re-render
  function swapVariant(key, newId) {
    if (busy) return;
    busy = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var line = cart.items.filter(function (i) { return i.key === key; })[0];
      var qty = line ? line.quantity : 1;
      return fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function () {
        return fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: newId, quantity: qty })
        });
      });
    }).then(function () { return refresh(); }).then(syncHeaderCount).finally(function () { busy = false; });
  }

  // ── keep the header cart count in sync ──────────────────────────
  function syncHeaderCount() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-bind="itemCount"], .nmd-bag-count, [data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
      });
    });
  }

  // ── open when items are added anywhere on the site ──────────────
  // The whole site calls PXUTheme.jsAjaxCart.updateView()/showDrawer() after an
  // add. Point those at this drawer so nothing else has to change.
  function hookLegacy() {
    if (!window.PXUTheme) window.PXUTheme = {};
    window.PXUTheme.jsAjaxCart = window.PXUTheme.jsAjaxCart || {};
    window.PXUTheme.jsAjaxCart.updateView = function () { return refresh().then(syncHeaderCount); };
    window.PXUTheme.jsAjaxCart.showDrawer = function () { refresh().then(open); };
    window.PXUTheme.jsAjaxCart.closeDrawer = close;
  }
  hookLegacy();
  // re-assert after the theme's own script may have redefined it
  window.addEventListener('load', hookLegacy);

  window.NamaCart = { open: function () { refresh().then(open); }, close: close, refresh: refresh };
  bindEditors();
})();
